/**
 * MOD-05 Batch 4: Isolated REST API Client for Worked-on-Leave Reconciliation,
 * Compensatory Off Grants/Expiry, and Year-End Processing.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

export const leaveBatch4Api = {
  // Batch 4 Feature Gates & Config
  getBatch4Config: async () => {
    const res = await axios.get(`${BASE_URL}/api/leaves/batch4-config/`, { withCredentials: true });
    return res.data;
  },

  updateBatch4Config: async (configData) => {
    const res = await axios.put(`${BASE_URL}/api/leaves/batch4-config/`, configData, { withCredentials: true });
    return res.data;
  },

  // TASK-LEV-009: Worked-on-Leave Reconciliation
  getAttendanceReviews: async (params = '') => {
    const query = params ? `?${params}` : '';
    const res = await axios.get(`${BASE_URL}/api/leaves/reconciliation/reviews/${query}`, { withCredentials: true });
    return res.data;
  },

  scanAttendanceReviews: async (scanPayload) => {
    const res = await axios.post(`${BASE_URL}/api/leaves/reconciliation/reviews/`, scanPayload, { withCredentials: true });
    return res.data;
  },

  resolveAttendanceReview: async (reviewId, decisionPayload) => {
    const res = await axios.post(
      `${BASE_URL}/api/leaves/reconciliation/reviews/${reviewId}/resolve/`,
      decisionPayload,
      { withCredentials: true }
    );
    return res.data;
  },

  // TASK-LEV-010: Compensatory Off Grants & 60-Day Expiry
  getCompOffCredits: async (params = '') => {
    const query = params ? `?${params}` : '';
    const res = await axios.get(`${BASE_URL}/api/leaves/comp-off/${query}`, { withCredentials: true });
    return res.data;
  },

  requestCompOffCredit: async (claimPayload) => {
    const res = await axios.post(`${BASE_URL}/api/leaves/comp-off/`, claimPayload, { withCredentials: true });
    return res.data;
  },

  approveCompOffCredit: async (creditId, decisionNotes = '') => {
    const res = await axios.post(
      `${BASE_URL}/api/leaves/comp-off/${creditId}/approve/`,
      { decision_notes: decisionNotes },
      { withCredentials: true }
    );
    return res.data;
  },

  rejectCompOffCredit: async (creditId, decisionNotes = '') => {
    const res = await axios.post(
      `${BASE_URL}/api/leaves/comp-off/${creditId}/reject/`,
      { decision_notes: decisionNotes },
      { withCredentials: true }
    );
    return res.data;
  },

  sweepCompOffExpiry: async (asOfDate, dryRun = true) => {
    const res = await axios.post(
      `${BASE_URL}/api/leaves/comp-off/expire/`,
      { as_of_date: asOfDate, dry_run: dryRun },
      { withCredentials: true }
    );
    return res.data;
  },

  // TASK-LEV-008: Year-End Preview & Controlled Rollover
  previewYearEnd: async (cycleYear) => {
    const res = await axios.post(
      `${BASE_URL}/api/leaves/year-end/preview/`,
      { cycle_year: cycleYear },
      { withCredentials: true }
    );
    return res.data;
  },

  executeYearEnd: async (cycleYear) => {
    const res = await axios.post(
      `${BASE_URL}/api/leaves/year-end/execute/`,
      { cycle_year: cycleYear },
      { withCredentials: true }
    );
    return res.data;
  },

  getYearEndBatches: async () => {
    const res = await axios.get(`${BASE_URL}/api/leaves/year-end/batches/`, { withCredentials: true });
    return res.data;
  },
};

